const RootActionTypes = {
    RESET_REDUX: "RESET_REDUX",
};

export default RootActionTypes;